import { GET_AIRLINE_ID_BY_CODE } from "../queries";
import { apolloClient } from "@crispico/foundation-react";
import { FilterOperators } from "@crispico/foundation-gwt-js";
import { AbstractAction } from "components/ContextMenuRegistry";
import { Filter } from "@crispico/foundation-react/components/CustomQuery/Filter";
import { AppMetaTempGlobals } from "@crispico/foundation-react/AppMetaTempGlobals";
import { entityDescriptors } from "@crispico/foundation-react/entity_crud/entityCrudConstants";
import { FindByFilterParams } from "@crispico/foundation-react/entity_crud/FindByFilterParams";
import { IActionParam, IActionParamForRun } from "@crispico/react-timeline-10000/types/components/ContextMenu/IAction";

interface FlightInfo {
    id: any;
    airline: string;
}

const AIRLINE_CONTACTS_TAB = "/Airline contacts";

export class ShowContactsAction extends AbstractAction {

    icon = "address book";
    label = _msg("ShowContactsAction.label");

    isVisible(param: IActionParam) {
        return param.selection.length > 0 && this.getEntityName(param.selection[0]) === "Flight";
    }

    async run(param: IActionParamForRun) {
        const { airline } = this.props.getEntityAt(param.selection[0]) as FlightInfo;
        const airlineId = (await apolloClient.query({
            query: GET_AIRLINE_ID_BY_CODE,
            variables: FindByFilterParams.create().filter(Filter.createComposed(FilterOperators.forComposedFilter.and, [Filter.create("code", FilterOperators.forString.equals, airline)])),
        })).data["airlineService_findByFilter"].results[0].id;

        AppMetaTempGlobals.history.push(entityDescriptors["Airline"].getEntityEditorUrl(airlineId) + AIRLINE_CONTACTS_TAB);
    }

}